import { AlertDecagramIcon } from './AlertDecagramIcon';

/**
 * author: Google
 * id B4866C08-2DAE-4B0A-8942-E057094B3C76
 * name alert-decagram
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-decagram.svg
 * tags
 * - Alert / Error 
 */
export const NewReleasesIcon = AlertDecagramIcon;
export default NewReleasesIcon